
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'container': {'bottom': `0`,'position': `fixed`,'display': `flex`,'flexDirection': `column`,'justifyContent': `center`,'borderRadius': `100%`,'backgroundColor': `#ffffff`,'alignItems': `center`,'padding': `8px`,'margin': `8px`,'borderColor': `#ffffff`,'borderStyle': `solid`,'borderWidth': `2px`,'zIndex': `130`,'cursor': `pointer`,'width': `50px`,},'checkoutTextStyles': {'color': `#000000`,},'cartBadge': {'right': `0px`,'color': `#ffffff`,'backgroundColor': `#be1e2d`,},
        
      };
    };
  